import React, { Fragment } from 'react';

// Components
import { Grid, Tooltip, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { SelectInput } from '../../../SelectInput';
import { SelectAll } from '../../../SelectAll';

// Styles
import { DeleteRounded } from '@mui/icons-material';
import { CustomGrid, StickyHeader, CustomControlLabel } from './styles';
import { CustomButtonV2, CustomIconButtonDemo } from '../../../../pages/styles';

// Utils
import { useTranslation } from 'react-i18next'
import { ColorsContext } from "../../../../Context/ColorsContext"

export const ContractScope = ({
    data,
    errors,
    contractList,
    handleChange,
    handleAddRow,
    handleRemoveRow,
    disabled,
    showCheckSupervisor
}) => {

    const { t } = useTranslation();
    const { colors } = React.useContext(ColorsContext);

    function returnSelectedData(arraySelected, list) {
		// Logic for MUI Autocomplete component bug
		// Data of autocomplete multiple must be taken directly from options array
        let setlData = []
        if (!list) {
            return []
        }
        arraySelected?.map((el) => {
            let objData = list?.filter((obj) => obj.id === el.id)
            setlData.push(...objData)
        })
        return setlData
    }

    return (
		<>
			<div style={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100%', minHeight: 0, overflowX: 'auto' }}>
				<CustomGrid container>

					<StickyHeader item xs={showCheckSupervisor ? 3 : 4} xl={showCheckSupervisor ? 2.5 : 3}>
            {t('contract.table.code')}
          </StickyHeader>

					<StickyHeader item xs={showCheckSupervisor ? 3 : 6} xl={showCheckSupervisor ? 7 : 7.5}>
            {t('contract.table.scope')}
          </StickyHeader>

					{showCheckSupervisor && 
            <StickyHeader item xs={showCheckSupervisor ? 3 : 4} xl={1.5}>
              {t('contract.table.supervisor')}
            </StickyHeader>
          }

					<StickyHeader item xs={2} xl={showCheckSupervisor ? 1 : 1.5}>
            {t('common.actions.delete')}
          </StickyHeader>

					{data?.map((row, index) => (
						<Fragment key={`contract-${index}`}>
							<Grid item xs={showCheckSupervisor ? 3 : 4} xl={showCheckSupervisor ? 2.5 : 3}>
								<SelectInput
									placeholder={t('contract.table.code')}
									onChange={(value) => handleChange('contract', value, index)}
									value={row.contract}
									options={contractList}
									keyValue="code"
									sx={{ width: '25%', fontSize: 10 }}
									error={errors?.['contractPlantsAssigned']?.[index]?.errorEmptyContract}
									disableCloseOnSelect={false}
									disableClearable={true}
									disabled={disabled}
								/>
							</Grid>
							<Grid item xs={showCheckSupervisor ? 3 : 6} xl={showCheckSupervisor ? 7 : 7.5}>
								<SelectAll
									onChange={(value) => handleChange('plants', value, index)}
									value={returnSelectedData(row.selectedPlants, row.plants)}
									options={row.plants || []}
									keyValue="name"
									sx={{ width: '25%' }}
									multiple={true}
									hasError={errors?.['contractPlantsAssigned']?.[index]?.hasEmptyPlants}
									messageError={errors?.['contractPlantsAssigned']?.[index]?.errorEmptyPlants}
									disabled={!row.contract?.id}
								/>
							</Grid>
							{showCheckSupervisor && 
								<Grid item xs={showCheckSupervisor ? 3 : 4} xl={1.5}>
									<CustomControlLabel
										control={
											<RadioGroup
												value={row.userType}
												defaultValue={2}
												name="radio-buttons-group"
												sx={{
													color: colors.grayGraphic,
												}}
												onChange={(e) => handleChange('userType', e.target.value, index)}
											>
												<FormControlLabel 
													value="1" 
													control={
														<Radio 
															sx={{
																color: colors.grayGraphic,
																margin: 0,
																'&.Mui-checked': {
																	color: colors.buttonActionColor
																}
															}}
														/>
													} 
													label={t('contract.table.optYes')}
												/>
												<FormControlLabel 
													value="2" 
													control={
														<Radio 
															sx={{
																color: colors.grayGraphic,
																margin: 0,
																'&.Mui-checked': {
																	color: colors.buttonActionColor
																}
															}}
														/>
													} 
													label={t('contract.table.optNo')}
												/>
											</RadioGroup>
										} 
									/>
								</Grid>
							}
							<Grid item xs={2} xl={showCheckSupervisor ? 1 : 1.5}>
								<Grid container display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'} sx={{ height: '100%' }}>
									<Grid item xs={12} sx={{ display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center' }}>
										<Tooltip title={t('contract.remove')}>
											<CustomIconButtonDemo
												btnType="delete"
												onClick={() => handleRemoveRow(index)}
												disabled={disabled}
												size="small"
											>
												<DeleteRounded/>
											</CustomIconButtonDemo>
										</Tooltip>
									</Grid>
								</Grid>
							</Grid>
						</Fragment>
					))}
				</CustomGrid>
			</div>

			<div style={{ marginTop: '10px' }}>
				<CustomButtonV2
          btnType="primary"
          onClick={handleAddRow}
          disabled={disabled}
          sx={{ width: {xs: '40%', sm: '20%'} }}>
					{t('contract.addAnother')}
				</CustomButtonV2>
			</div>
		</>
    )
}